import React, {PropTypes} from 'react'

import BigBreadcrumbs from '../layout/navigation/components/BigBreadcrumbs.jsx'
import WidgetGrid from '../layout/widgets/WidgetGrid.jsx'
import JarvisWidget from '../layout/widgets/JarvisWidget.jsx'

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button } from 'react-bootstrap';

export default class NotificationList extends React.Component{

  updateDateFormatter(cell, row) {

      return formatDate(new Date(row.created_at), 'YYYY年MM月DD日 hh:mm:ss');
  }
  osFormatter(cell, row) {
    if(row.os === 1)
      return 'iOS';
    else if(row.os === 2)
      return 'Android';
    else
      return 'All';
  }
  openRateFormatter(cell, row) {
    if(row.open_rate)
      return row.open_rate.toFixed(0)+'%';
  }

  render(){
    return <div id="content">
        <div className="row">
            <BigBreadcrumbs items={['Table', 'Data Tables']} icon="table" className="col-xs-12 col-sm-7 col-md-7 col-lg-4" />
        </div>

        <WidgetGrid>

            <div className="row">
                <article className="col-sm-12">

                    <JarvisWidget editbutton={false} color="darken" >
                        <header>
                            <span className="widget-icon">
                                <i className="fa fa-table" />
                            </span>
                            <h2>通知リスト</h2>
                        </header>
                        <div>
                            <div className="widget-body no-padding">
                              <BootstrapTable
                                  data={this.props.notifications}
                                  options={{sizePerPage: 15}}
                                  pagination
                                  >
                                  <TableHeaderColumn dataField='id' width='50px' isKey>ID</TableHeaderColumn>
                                  <TableHeaderColumn dataField='title' width='25%' columnClassName='td-column-wrap'>Title</TableHeaderColumn>
                                  <TableHeaderColumn dataField='body' columnClassName='td-column-wrap'>Body</TableHeaderColumn>
                                  <TableHeaderColumn dataField='send_success' width='60px' >送信</TableHeaderColumn>
                                  <TableHeaderColumn dataField='send_failure' hidden></TableHeaderColumn>
                                  <TableHeaderColumn dataField='open_rate' width='60px' dataFormat={this.openRateFormatter}>開封率</TableHeaderColumn>
                                  <TableHeaderColumn dataField='type' hidden></TableHeaderColumn>
                                  <TableHeaderColumn dataField='os' width='70px' dataFormat={this.osFormatter}>OS</TableHeaderColumn>
                                  <TableHeaderColumn dataField='status' width='50px' hidden></TableHeaderColumn>
                                  <TableHeaderColumn dataField='created_at' width='200px' dataFormat={this.updateDateFormatter} headerAlign='center' dataAlign='center'>発信日</TableHeaderColumn>
                              </BootstrapTable>

                            </div>
                        </div>
                    </JarvisWidget>
                </article>

            </div>

        </WidgetGrid>

    </div>
  }
}

NotificationList.propTypes = {
  notifications: PropTypes.array.isRequired
}

var formatDate = function(date, format) {
    if (!format)
        format = 'YYYY-MM-DD hh:mm:ss.SSS';
    format = format.replace(/YYYY/g, date.getFullYear());
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    if (format.match(/S/g)) {
        var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
        var length = format.match(/S/g).length;
        for (var i = 0; i < length; i++)
            format = format.replace(/S/, milliSeconds.substring(i, i + 1));
    }
    return format;
};



// WEBPACK FOOTER //
// ./src/components/notification/NotificationTable.js